import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config";
import constants from "../constants";
import backendAPI from "../services/backend";
import WaitingModal from "./Modals/waitingModal/WaitingModal";
import {
  getCloudEnv,
  isTokenValid,
  setCloudEnv,
  shouldUsePopupAuth
} from "./utilities/authConstants";

const Main = () => {
  const navigate = useNavigate();
  const [isWaitingModalOpen, setIsWaitingModalOpen] = useState(false);
  const [waitingHeader, setWaitingHeader] = useState();

  // Validates the authenticated user against the backend and routes them on.
  const handleUserValidation = async () => {
    const token = sessionStorage.getItem(constants.GC_TOKEN);
    if (!token) {
      navigate("/purecloudlogin");
      return;
    }
    try {
      setWaitingHeader("User authenticating");
      setIsWaitingModalOpen(true);
      const usersMe = await backendAPI.getUsersMe(token);
      const isUser = usersMe.user.role.value;

      console.log("isUser : ", isUser);
      let redirectUrl =
        sessionStorage.getItem("redirect_to") ?? "/conversations";
      navigate(isUser ? redirectUrl : "/unauthorized");
    } catch (error) {
      console.error(`Error during authentication: ${error.message}`);
      if (
        error &&
        error.message &&
        error.message === "Your search returned no recordings for this user."
      ) {
        navigate({
          pathname: "/unauthorized",
          state: { message: error.message },
        });
      } else {
        navigate("/unauthorized");
      }
    }
  };

  // Initializes component.
  useEffect(() => {
    const init = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      // On the post-login pass Main re-mounts WITHOUT a query string, so we
      // must fall back to the env the user actually authenticated against
      // (persisted by PureCloudLogin/OAuthCallback) before the config default.
      // Otherwise we clobber the region and getUsersMe hits the wrong API host,
      // failing with a 401 and bouncing the user to /unauthorized.
      const environment =
        urlParams.get("environment") || getCloudEnv() || config.defaultEnvironment;
      // Persist env (legacy key) so the PKCE flow and SDK can pick the region.
      sessionStorage.setItem(constants.GC_ENVIRONMENT, environment);
      setCloudEnv(environment);
      // Capture an AppFoundry `usePopupAuth` choice while the original query
      // string is still present (PureCloudLogin reads it from storage).
      shouldUsePopupAuth();

      // PKCE replaces the implicit-grant popup. If we do not already hold a
      // valid token, kick off the PKCE login flow.
      if (!isTokenValid()) {
        navigate("/purecloudlogin" + window.location.search);
        return;
      }
      handleUserValidation();
    };
    init();
  }, []);

  return (
    <Fragment>
      <WaitingModal isOpen={isWaitingModalOpen} header={waitingHeader} />
    </Fragment>
  );
};

export default Main;
